import { sizeConst } from '@klarna/designtokens';
var cornerRadii = {
  none: 0,
  xs: 4,
  s: 8,
  m: 16,
  l: 32,
  round: 9999
};
function cornerRadiusFromParameters(cornerRadius) {
  return {
    'corner-radius/none': sizeConst(cornerRadius.none),
    'corner-radius/xs': sizeConst(cornerRadius.xs),
    'corner-radius/s': sizeConst(cornerRadius.s),
    'corner-radius/m': sizeConst(cornerRadius.m),
    'corner-radius/l': sizeConst(cornerRadius.l),
    'corner-radius/round': sizeConst(cornerRadius.round)
  };
}
export var defaultCornerRadii = cornerRadiusFromParameters(cornerRadii);
//# sourceMappingURL=index.js.map